import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostManualTreeChapterDelete } from '../../../../../../api/manual-tree/manual-tree';
import { ErrorInfo } from '../../../../../../api/model';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ConfirmModal from '../../../../../modules/ConfirmModal';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  chapterId: number | undefined;
  productionId: number | undefined;
};
function SectionChapterMenuDelete({ chapterId, productionId }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { data, mutateAsync, isSuccess, isLoading, isError, error } = usePostManualTreeChapterDelete<
    AxiosError<ErrorInfo>,
    unknown
  >(options);

  const [displayDeleteError, setDisplayDeleteError] = useState(false);
  const [displayConfirm, setDisplayConfirm] = useState(false);

  const handlePreview = async () => {
    await mutateAsync({ chapterId: Number(chapterId) });
  };

  useEffect(() => {
    if (isSuccess) {
      if (productionId) {
        const basePath = process.env.REACT_APP_ROUTER_BASEPATH || '';
        window.location.href = `${basePath}/${language}/productions/sections/${productionId}/ps?section_id=${Number(
          data.data.section_id
        )}`;
      }
    }
  }, [isSuccess, productionId, language, data?.data.section_id]);

  useEffect(() => {
    setDisplayDeleteError(isError);
  }, [isError]);

  return (
    <>
      <li style={{ marginTop: '25px' }} onClick={() => setDisplayConfirm(true)}>
        <i className="fa-solid fa-circle-xmark" />
        {t('章削除')}
      </li>
      {/* 章削除確認 */}
      {displayConfirm && (
        <ConfirmModal
          onClickCancel={() => setDisplayConfirm(false)}
          onClickOk={() => {
            setDisplayConfirm(false);
            void handlePreview();
          }}
        >
          {t('L1文書以下を全て削除します。削除後は元に戻せませんがよろしいですか？')}
        </ConfirmModal>
      )}
      {/* スピナーモーダル */}
      {isLoading && <SpinnerModal />}
      {/* エラー */}
      {displayDeleteError && <ErrorModal error={error} onClickOk={() => setDisplayDeleteError(false)} />}
    </>
  );
}
export { SectionChapterMenuDelete };
